require('angular').module('oly.common')
    .directive('wowSelectContainer', [require('./select.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/select/index.js